import {Directive, Input} from '@angular/core';
import {UntypedFormControl, NG_VALIDATORS} from '@angular/forms';

/**
 * Email format validator
 *
 */
function emailValidatorFactory() {
  return (value: string, trimWhiteSpace: boolean) => {

    // *Note* This is the same regex as we use across all of our apps. Any bugs or approved changes should be replicated across.
    const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const noError: any = null;
    const error = {
      emailFormatValidator: {
        emailFormat: {
          invalid: true
        }
      }
    };

    if (trimWhiteSpace && value) value = value.trim();
    if(value === '') return noError;
    if (!emailRegEx.test(value)) return error;
    return noError;
  };
}

/**
 * Required validator directive
 */
@Directive({
    selector: '[appEmailRegexValidator]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: EmailRegexValidatorDirective, multi: true }
    ],
    standalone: false
})
export class EmailRegexValidatorDirective {

  @Input() emailTrimWhiteSpace = false;

  validator: Function;

  constructor() {
    this.validator = emailValidatorFactory();
  }

  /**
   * Validation will pass along referee ID if the selected work history ID equals the route param
   * work history ID. This to avoid false negatives when validating.
   */
  validate(c: UntypedFormControl): any {
    return this.validator(c === null ? '' : c.value, this.emailTrimWhiteSpace);
  }
}
